const Xd = 0, t = "768px", e = "1280px", o = "8px", n = "8px", r = "8px", a = "8px", c = "8px", i = "8px", s = "8px", l = "8px", d = "8px", f = "9999px", m = "9999px", S = "9999px", u = "9999px", g = "9999px", p = "9999px", b = "9999px", v = "9999px", B = "9999px", _d = {
  large: {
    radius: {
      mobile: f,
      tablet: m,
      desktop: S
    }
  },
  medium: {
    radius: {
      mobile: u,
      tablet: g,
      desktop: p
    }
  },
  small: {
    radius: {
      mobile: b,
      tablet: v,
      desktop: B
    }
  }
}, Vd = {
  mobile: 0,
  tablet: t,
  desktop: e
}, jd = {
  small: {
    radius: {
      mobile: o,
      tablet: n,
      desktop: r
    }
  },
  medium: {
    radius: {
      mobile: a,
      tablet: c,
      desktop: i
    }
  },
  large: {
    radius: {
      mobile: s,
      tablet: l,
      desktop: d
    }
  }
}, qd = 0, Ed = "1px", Gd = "2px", y = "linear-gradient(var(--gradient-angle, 90deg), var(--spirit-color-gradient-basic-overlay-color-01, #fff) 0%, var(--spirit-color-gradient-basic-overlay-color-02, #fff0) 100%)", k = "linear-gradient(var(--gradient-angle, 180deg), var(--spirit-color-gradient-primary-color-01, #eae3ff) 0%, var(--spirit-color-gradient-primary-color-02, #cebcff) 100%)", $ = "linear-gradient(var(--gradient-angle, 180deg), var(--spirit-color-gradient-secondary-color-01, #fff) 0%, var(--spirit-color-gradient-secondary-color-02, #a7d9e2) 100%)", h = "linear-gradient(var(--gradient-angle, 135deg), var(--spirit-color-gradient-skeleton-color-01, #e5e5e5) 33%, var(--spirit-color-gradient-skeleton-color-02, #fff) 48.5%, var(--spirit-color-gradient-skeleton-color-03, #e5e5e5) 66%)", Jd = {
  basicOverlay: y,
  primary: k,
  secondary: $,
  skeleton: h
}, H = "16px", F = "32px", C = "32px", I = "480px", D = "640px", x = "768px", W = "1024px", A = "1280px", T = "1280px", P = "16px", z = "32px", w = "32px", R = "12", Kd = "spirit-", Nd = {
  padding: {
    mobile: H,
    tablet: F,
    desktop: C
  },
  xsmall: {
    maxWidth: I
  },
  small: {
    maxWidth: D
  },
  medium: {
    maxWidth: x
  },
  large: {
    maxWidth: W
  },
  maxWidth: A,
  xlarge: {
    maxWidth: T
  }
}, Qd = {
  spacing: {
    mobile: P,
    desktop: z,
    tablet: w
  },
  columns: R
}, M = 0, U = "2px", L = "4px", O = "8px", X = "12px", _ = "16px", V = "9999px", Yd = {
  0: M,
  100: U,
  200: L,
  300: O,
  400: X,
  500: _,
  full: V
}, j = "0 0 0 2px var(--spirit-color-focus-focus-ring-color-01, #d2c2ffb2)", q = "0 2px 8px 0 var(--spirit-color-shadow-shadow-100-color-01, #00000026)", E = "0 4px 12px 0 var(--spirit-color-shadow-shadow-200-color-01, #0003)", G = "0 8px 24px 0 var(--spirit-color-shadow-shadow-300-color-01, #00000040)", J = "0 12px 32px 0 var(--spirit-color-shadow-shadow-400-color-01, #00000040)", Zd = {
  focusRing: j
}, tf = {
  100: q,
  200: E,
  300: G,
  400: J
}, K = 0, N = "1px", Q = "2px", Y = "4px", Z = "6px", tt = "8px", et = "12px", ot = "16px", nt = "20px", rt = "24px", at = "32px", ct = "40px", it = "48px", st = "56px", lt = "64px", dt = "72px", ft = "80px", mt = "96px", ef = {
  0: K,
  100: N,
  200: Q,
  300: Y,
  400: Z,
  500: tt,
  600: et,
  700: ot,
  800: nt,
  900: rt,
  1e3: at,
  1100: ct,
  1200: it,
  1300: st,
  1400: lt,
  1500: dt,
  1600: ft,
  1700: mt
}, St = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  }
}, ut = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, gt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, pt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, bt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, vt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, Bt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, yt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, kt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, $t = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, ht = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.2
  }
}, Ht = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.3
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  }
}, Ft = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  }
}, Ct = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.4
  }
}, It = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Dt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, xt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Wt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, At = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: 1.5
  }
}, Tt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.5
  }
}, Pt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, zt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, wt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, Rt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, Mt = {
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.5
  }
}, Ut = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  }
}, Lt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  }
}, Ot = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Xt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  }
}, _t = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "48px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "36px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Vt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, jt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.2
  }
}, qt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "40px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.2
  }
}, Et = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.3
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Gt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.3
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: 1.4
  }
}, Jt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.3
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "32px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.3
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Kt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Nt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "24px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Qt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, Yt = {
  desktop: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  tablet: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  },
  mobile: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "18px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: 1.4
  }
}, of = {
  headingXlargeBold: St,
  bodyMediumRegular: ut,
  bodyLargeRegular: gt,
  bodyLargeBold: pt,
  bodyLargeItalic: bt,
  bodyMediumBold: vt,
  bodyMediumItalic: Bt,
  bodySmallRegular: yt,
  bodySmallBold: kt,
  bodySmallItalic: $t,
  headingLargeBold: ht,
  headingMediumBold: Ht,
  headingSmallBold: Ft,
  headingXsmallBold: Ct,
  bodyXsmallRegular: It,
  bodyXsmallBold: Dt,
  bodyXsmallItalic: xt,
  bodyXlargeRegular: Wt,
  bodyXlargeBold: At,
  bodyXlargeItalic: Tt,
  bodyXlargeSemibold: Pt,
  bodyLargeSemibold: zt,
  bodyMediumSemibold: wt,
  bodySmallSemibold: Rt,
  bodyXsmallSemibold: Mt,
  headingSmallSemibold: Ut,
  headingXsmallSemibold: Lt,
  headingXlargeRegular: Ot,
  headingXlargeSemibold: Xt,
  headingXlargeItalic: _t,
  headingLargeRegular: Vt,
  headingLargeSemibold: jt,
  headingLargeItalic: qt,
  headingMediumRegular: Et,
  headingMediumSemibold: Gt,
  headingMediumItalic: Jt,
  headingSmallRegular: Kt,
  headingSmallItalic: Nt,
  headingXsmallRegular: Qt,
  headingXsmallItalic: Yt
}, Zt = "#ffbe00", te = "#fff8e5", ee = "#a67c00", oe = "#fff8e5", ne = "#ffbe00", re = "#fff8e5", ae = "#cc9800", ce = "#ffbe00", ie = "#e5ab00", se = "#0066d8", le = "#e5f0fb", de = "#0066d8", fe = "#e5f0fb", me = "#0052ad", Se = "#e5f0fb", ue = "#3385e0", ge = "#66a3e8", pe = "#4d94e4", be = "#1a1b1b80", ve = "#f1edff", Be = "#fff0", ye = "#f8f6ff", ke = "#fff", $e = "#f2f2f2", he = "#f1edff", He = "#d9d9d9", Fe = "#7847ff", Ce = "#a5a5a5", Ie = "#bfbfbf", De = "#b2b2b2", xe = "#7847ff", We = "#fff0", Ae = "#6039cc", Te = "#e4daff", Pe = "#fff0", ze = "#f1edff", we = "#4e2ea6", Re = "#fff", Me = "#6039cc", Ue = "#7847ff", Le = "#6c40e5", Oe = "#7847ff", Xe = "#6039cc", _e = "#e4daff", Ve = "#fff", je = "#f1edff", qe = "#e5e5e5", Ee = "#202020", Ge = "#d9d9d9", Je = "#f2f2f2", Ke = "#e5e5e5", Ne = "#fff", Qe = "#e5e5e5", Ye = "#f1edff", Ze = "#fff0", to = "#f8f6ff", eo = "#f8f6ff", oo = "#4e2ea6", no = "#404040", ro = "#6039cc", ao = "#6039cc", co = "#ffbe00", io = "#e4daff", so = "#327c3f", lo = "#fff", fo = "#3e9b4f", mo = "#327c3f", So = "#388b47", uo = "#a5a5a5", go = "#404040", po = "#f2f2f2", bo = "#fff", vo = "#f9f9f9", Bo = "#f9f9f9", yo = "#e5e5e5", ko = "#a5a5a5", $o = "#d9d9d9", ho = "#b60000", Ho = "#fef2f2", Fo = "#b60000", Co = "#f18080", Io = "#940000", Do = "#fff", xo = "#e40000", Wo = "#b60000", Ao = "#cd0000", To = "#0052ad", Po = "#f2f7fd", zo = "#0052ad", wo = "#80b2eb", Ro = "#00428c", Mo = "#fff", Uo = "#0066d8", Lo = "#0052ad", Oo = "#005cc2", Xo = "#327c3f", _o = "#f5faf6", Vo = "#327c3f", jo = "#9ecda7", qo = "#286533", Eo = "#fff", Go = "#3e9b4f", Jo = "#327c3f", Ko = "#388b47", No = "#c26400", Qo = "#fef8f2", Yo = "#c26400", Zo = "#f9be80", tn = "#9d5100", en = "#fff", on = "#f27d00", nn = "#c26400", rn = "#da7100", an = "#d2c2ffb2", cn = "#b60000", sn = "#fff", ln = "#fff", dn = "#f9f9f9", fn = "#7f7f7f", mn = "#a5a5a5", Sn = "#999", un = "#7847ff", gn = "#202020", pn = "#666", bn = "#7f7f7f", vn = "#202020", Bn = "#327c3f", yn = "#c26400", kn = "#fff", $n = "#fff0", hn = "#eae3ff", Hn = "#cebcff", Fn = "#fff", Cn = "#a7d9e2", In = "#e5e5e5", Dn = "#fff", xn = "#e5e5e5", Wn = "#3c2480", An = "#6039cc", Tn = "#4e2ea6", Pn = "#3c2480", zn = "#535353", wn = "#4e2ea6", Rn = "#3c2480", Mn = "#3c2480", Un = "#7f7f7f", Ln = "#4e2ea6", On = "#202020", Xn = "#f2f2f2", _n = "#202020", Vn = "#bfbfbf", jn = "#202020", qn = "#fff", En = "#535353", Gn = "#202020", Jn = "#404040", Kn = "#4e2ea6", Nn = "#fff", Qn = "#6039cc", Yn = "#7847ff", Zn = "#6c40e5", tr = "#00000026", er = "#0003", or = "#00000040", nr = "#00000040", rr = "#202020", ar = "#535353", cr = "#7f7f7f", ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accent01BackgroundBasic: Zt,
  accent01BackgroundSubtle: te,
  accent01BorderBasic: ee,
  accent01BorderSubtle: oe,
  accent01ContentBasic: ne,
  accent01ContentSubtle: re,
  accent01StateActive: ae,
  accent01StateDefault: ce,
  accent01StateHover: ie,
  accent02BackgroundBasic: se,
  accent02BackgroundSubtle: le,
  accent02BorderBasic: de,
  accent02BorderSubtle: fe,
  accent02ContentBasic: me,
  accent02ContentSubtle: Se,
  accent02StateActive: ue,
  accent02StateDefault: ge,
  accent02StateHover: pe,
  backgroundBackdrop: be,
  backgroundInteractiveStateActive: ve,
  backgroundInteractiveStateDefault: Be,
  backgroundInteractiveStateHover: ye,
  backgroundPrimary: ke,
  backgroundSecondary: $e,
  backgroundTertiary: he,
  borderBasic: He,
  borderFocus: Fe,
  borderInteractiveStateActive: Ce,
  borderInteractiveStateDefault: Ie,
  borderInteractiveStateHover: De,
  borderInteractiveStateSelected: xe,
  componentButtonPlainBorder: We,
  componentButtonPlainContent: Ae,
  componentButtonPlainStateActive: Te,
  componentButtonPlainStateDefault: Pe,
  componentButtonPlainStateHover: ze,
  componentButtonPrimaryBorder: we,
  componentButtonPrimaryContent: Re,
  componentButtonPrimaryStateActive: Me,
  componentButtonPrimaryStateDefault: Ue,
  componentButtonPrimaryStateHover: Le,
  componentButtonSecondaryBorder: Oe,
  componentButtonSecondaryContent: Xe,
  componentButtonSecondaryStateActive: _e,
  componentButtonSecondaryStateDefault: Ve,
  componentButtonSecondaryStateHover: je,
  componentButtonTertiaryBorder: qe,
  componentButtonTertiaryContent: Ee,
  componentButtonTertiaryStateActive: Ge,
  componentButtonTertiaryStateDefault: Je,
  componentButtonTertiaryStateHover: Ke,
  componentHeaderBackground: Ne,
  componentHeaderBorder: Qe,
  componentHeaderItemBackgroundStateActive: Ye,
  componentHeaderItemBackgroundStateDefault: Ze,
  componentHeaderItemBackgroundStateHover: to,
  componentHeaderItemBackgroundStateSelected: eo,
  componentHeaderItemStateActive: oo,
  componentHeaderItemStateDefault: no,
  componentHeaderItemStateHover: ro,
  componentHeaderItemStateSelected: ao,
  componentHeaderStripeStateSelected: co,
  componentHeaderStripeStateUnselected: io,
  componentToggleSelectedBorder: so,
  componentToggleSelectedContent: lo,
  componentToggleSelectedStateActive: fo,
  componentToggleSelectedStateDefault: mo,
  componentToggleSelectedStateHover: So,
  componentToggleUnselectedBorder: uo,
  componentToggleUnselectedContent: go,
  componentToggleUnselectedStateActive: po,
  componentToggleUnselectedStateDefault: bo,
  componentToggleUnselectedStateHover: vo,
  disabledBackground: Bo,
  disabledBorder: yo,
  disabledContent: ko,
  disabledForeground: $o,
  emotionDangerBackgroundBasic: ho,
  emotionDangerBackgroundSubtle: Ho,
  emotionDangerBorderBasic: Fo,
  emotionDangerBorderSubtle: Co,
  emotionDangerContentBasic: Io,
  emotionDangerContentSubtle: Do,
  emotionDangerStateActive: xo,
  emotionDangerStateDefault: Wo,
  emotionDangerStateHover: Ao,
  emotionInformativeBackgroundBasic: To,
  emotionInformativeBackgroundSubtle: Po,
  emotionInformativeBorderBasic: zo,
  emotionInformativeBorderSubtle: wo,
  emotionInformativeContentBasic: Ro,
  emotionInformativeContentSubtle: Mo,
  emotionInformativeStateActive: Uo,
  emotionInformativeStateDefault: Lo,
  emotionInformativeStateHover: Oo,
  emotionSuccessBackgroundBasic: Xo,
  emotionSuccessBackgroundSubtle: _o,
  emotionSuccessBorderBasic: Vo,
  emotionSuccessBorderSubtle: jo,
  emotionSuccessContentBasic: qo,
  emotionSuccessContentSubtle: Eo,
  emotionSuccessStateActive: Go,
  emotionSuccessStateDefault: Jo,
  emotionSuccessStateHover: Ko,
  emotionWarningBackgroundBasic: No,
  emotionWarningBackgroundSubtle: Qo,
  emotionWarningBorderBasic: Yo,
  emotionWarningBorderSubtle: Zo,
  emotionWarningContentBasic: tn,
  emotionWarningContentSubtle: en,
  emotionWarningStateActive: on,
  emotionWarningStateDefault: nn,
  emotionWarningStateHover: rn,
  focusFocusRingColor01: an,
  formFieldDanger: cn,
  formFieldFilledBackgroundStateActive: sn,
  formFieldFilledBackgroundStateDefault: ln,
  formFieldFilledBackgroundStateHover: dn,
  formFieldFilledBorderStateActive: fn,
  formFieldFilledBorderStateDefault: mn,
  formFieldFilledBorderStateHover: Sn,
  formFieldFilledBorderStateSelected: un,
  formFieldFilledContent: gn,
  formFieldFilledPlaceholder: pn,
  formFieldHelperText: bn,
  formFieldLabel: vn,
  formFieldSuccess: Bn,
  formFieldWarning: yn,
  gradientBasicOverlayColor01: kn,
  gradientBasicOverlayColor02: $n,
  gradientPrimaryColor01: hn,
  gradientPrimaryColor02: Hn,
  gradientSecondaryColor01: Fn,
  gradientSecondaryColor02: Cn,
  gradientSkeletonColor01: In,
  gradientSkeletonColor02: Dn,
  gradientSkeletonColor03: xn,
  linkPrimaryStateActive: Wn,
  linkPrimaryStateDefault: An,
  linkPrimaryStateHover: Tn,
  linkSecondaryStateActive: Pn,
  linkSecondaryStateDefault: zn,
  linkSecondaryStateHover: wn,
  linkStateVisited: Rn,
  linkTertiaryStateActive: Mn,
  linkTertiaryStateDefault: Un,
  linkTertiaryStateHover: Ln,
  neutralBackgroundBasic: On,
  neutralBackgroundSubtle: Xn,
  neutralBorderBasic: _n,
  neutralBorderSubtle: Vn,
  neutralContentBasic: jn,
  neutralContentSubtle: qn,
  neutralStateActive: En,
  neutralStateDefault: Gn,
  neutralStateHover: Jn,
  selectedContentBasic: Kn,
  selectedContentSubtle: Nn,
  selectedStateActive: Qn,
  selectedStateDefault: Yn,
  selectedStateHover: Zn,
  shadowShadow100Color01: tr,
  shadowShadow200Color01: er,
  shadowShadow300Color01: or,
  shadowShadow400Color01: nr,
  textPrimary: rr,
  textSecondary: ar,
  textTertiary: cr
}, Symbol.toStringTag, { value: "Module" })), sr = "#ffbe00", lr = "#fff8e5", dr = "#a67c00", fr = "#fff8e5", mr = "#ffbe00", Sr = "#fff8e5", ur = "#cc9800", gr = "#ffbe00", pr = "#e5ab00", br = "#0066d8", vr = "#e5f0fb", Br = "#0066d8", yr = "#e5f0fb", kr = "#0052ad", $r = "#e5f0fb", hr = "#3385e0", Hr = "#66a3e8", Fr = "#4d94e4", Cr = "#1a1b1b80", Ir = "#ffffff1a", Dr = "#fff0", xr = "#ffffff0d", Wr = "#6039cc", Ar = "#3c2480", Tr = "#1e1240", Pr = "#a07eff", zr = "#1e1240", wr = "#bba3ff", Rr = "#a07eff", Mr = "#ae91ff", Ur = "#ffbe00", Lr = "#fff0", Or = "#fff", Xr = "#ffffff26", _r = "#fff0", Vr = "#ffffff1a", jr = "#1e1240", qr = "#3c2480", Er = "#e4daff", Gr = "#fff", Jr = "#f1edff", Kr = "#f8f6ff", Nr = "#fff", Qr = "#1a1b1b26", Yr = "#1a1b1b00", Zr = "#1a1b1b1a", ta = "#1a1b1b00", ea = "#fff", oa = "#1a1b1b4d", na = "#1a1b1b33", ra = "#1a1b1b40", aa = "#6039cc", ca = "#936cff", ia = "#1a1b1b26", sa = "#fff0", la = "#1a1b1b1a", da = "#4e2ea6", fa = "#e5e5e5", ma = "#fff", Sa = "#f2f2f2", ua = "#ffbe00", ga = "#fff", pa = "#ffffff40", ba = "#a07eff", va = "#fff", Ba = "#3e9b4f", ya = "#327c3f", ka = "#388b47", $a = "#a07eff", ha = "#4e2ea6", Ha = "#e4daff", Fa = "#fff", Ca = "#f1edff", Ia = "#ffffff1a", Da = "#fff3", xa = "#ffffff80", Wa = "#fff3", Aa = "#e40000", Ta = "#fce5e5", Pa = "#e93333", za = "#ef6666", wa = "#720000", Ra = "#fff", Ma = "#ec4d4d", Ua = "#e40000", La = "#e93333", Oa = "#0066d8", Xa = "#e5f0fb", _a = "#3385e0", Va = "#66a3e8", ja = "#00336c", qa = "#fff", Ea = "#4d94e4", Ga = "#0066d8", Ja = "#3385e0", Ka = "#3e9b4f", Na = "#ecf5ed", Qa = "#65af72", Ya = "#8bc395", Za = "#1f4e28", tc = "#fff", ec = "#78b984", oc = "#3e9b4f", nc = "#65af72", rc = "#f27d00", ac = "#fef2e5", cc = "#f59733", ic = "#f7b166", sc = "#793f00", lc = "#fff", dc = "#f6a44d", fc = "#f27d00", mc = "#f59733", Sc = "#d2c2ffb2", uc = "#ec4d4d", gc = "#fff", pc = "#f9f9f9", bc = "#f1edff", vc = "#936cff", Bc = "#ae91ff", yc = "#a07eff", kc = "#ffbe00", $c = "#202020", hc = "#666", Hc = "#c9b5ff", Fc = "#fff", Cc = "#78b984", Ic = "#f6a44d", Dc = "#606060", xc = "#60606000", Wc = "#7847ff", Ac = "#482b99", Tc = "#35818e", Pc = "#482b99", zc = "#6c40e5", wc = "#936cff", Rc = "#6c40e5", Mc = "#e5e5e5", Uc = "#fff", Lc = "#f2f2f2", Oc = "#e5e5e5", Xc = "#d6c8ff", _c = "#f2f2f2", Vc = "#ffbe00", jc = "#e5e5e5", qc = "#bba3ff", Ec = "#f2f2f2", Gc = "#202020", Jc = "#f2f2f2", Kc = "#202020", Nc = "#bfbfbf", Qc = "#202020", Yc = "#fff", Zc = "#535353", ti = "#202020", ei = "#404040", oi = "#fff", ni = "#3c2480", ri = "#ffd24d", ai = "#ffbe00", ci = "#ffcb33", ii = "#00000026", si = "#0003", li = "#00000040", di = "#00000040", fi = "#f9f9f9", mi = "#d9d9d9", Si = "#b2b2b2", ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accent01BackgroundBasic: sr,
  accent01BackgroundSubtle: lr,
  accent01BorderBasic: dr,
  accent01BorderSubtle: fr,
  accent01ContentBasic: mr,
  accent01ContentSubtle: Sr,
  accent01StateActive: ur,
  accent01StateDefault: gr,
  accent01StateHover: pr,
  accent02BackgroundBasic: br,
  accent02BackgroundSubtle: vr,
  accent02BorderBasic: Br,
  accent02BorderSubtle: yr,
  accent02ContentBasic: kr,
  accent02ContentSubtle: $r,
  accent02StateActive: hr,
  accent02StateDefault: Hr,
  accent02StateHover: Fr,
  backgroundBackdrop: Cr,
  backgroundInteractiveStateActive: Ir,
  backgroundInteractiveStateDefault: Dr,
  backgroundInteractiveStateHover: xr,
  backgroundPrimary: Wr,
  backgroundSecondary: Ar,
  backgroundTertiary: Tr,
  borderBasic: Pr,
  borderFocus: zr,
  borderInteractiveStateActive: wr,
  borderInteractiveStateDefault: Rr,
  borderInteractiveStateHover: Mr,
  borderInteractiveStateSelected: Ur,
  componentButtonPlainBorder: Lr,
  componentButtonPlainContent: Or,
  componentButtonPlainStateActive: Xr,
  componentButtonPlainStateDefault: _r,
  componentButtonPlainStateHover: Vr,
  componentButtonPrimaryBorder: jr,
  componentButtonPrimaryContent: qr,
  componentButtonPrimaryStateActive: Er,
  componentButtonPrimaryStateDefault: Gr,
  componentButtonPrimaryStateHover: Jr,
  componentButtonSecondaryBorder: Kr,
  componentButtonSecondaryContent: Nr,
  componentButtonSecondaryStateActive: Qr,
  componentButtonSecondaryStateDefault: Yr,
  componentButtonSecondaryStateHover: Zr,
  componentButtonTertiaryBorder: ta,
  componentButtonTertiaryContent: ea,
  componentButtonTertiaryStateActive: oa,
  componentButtonTertiaryStateDefault: na,
  componentButtonTertiaryStateHover: ra,
  componentHeaderBackground: aa,
  componentHeaderBorder: ca,
  componentHeaderItemBackgroundStateActive: ia,
  componentHeaderItemBackgroundStateDefault: sa,
  componentHeaderItemBackgroundStateHover: la,
  componentHeaderItemBackgroundStateSelected: da,
  componentHeaderItemStateActive: fa,
  componentHeaderItemStateDefault: ma,
  componentHeaderItemStateHover: Sa,
  componentHeaderItemStateSelected: ua,
  componentHeaderStripeStateSelected: ga,
  componentHeaderStripeStateUnselected: pa,
  componentToggleSelectedBorder: ba,
  componentToggleSelectedContent: va,
  componentToggleSelectedStateActive: Ba,
  componentToggleSelectedStateDefault: ya,
  componentToggleSelectedStateHover: ka,
  componentToggleUnselectedBorder: $a,
  componentToggleUnselectedContent: ha,
  componentToggleUnselectedStateActive: Ha,
  componentToggleUnselectedStateDefault: Fa,
  componentToggleUnselectedStateHover: Ca,
  disabledBackground: Ia,
  disabledBorder: Da,
  disabledContent: xa,
  disabledForeground: Wa,
  emotionDangerBackgroundBasic: Aa,
  emotionDangerBackgroundSubtle: Ta,
  emotionDangerBorderBasic: Pa,
  emotionDangerBorderSubtle: za,
  emotionDangerContentBasic: wa,
  emotionDangerContentSubtle: Ra,
  emotionDangerStateActive: Ma,
  emotionDangerStateDefault: Ua,
  emotionDangerStateHover: La,
  emotionInformativeBackgroundBasic: Oa,
  emotionInformativeBackgroundSubtle: Xa,
  emotionInformativeBorderBasic: _a,
  emotionInformativeBorderSubtle: Va,
  emotionInformativeContentBasic: ja,
  emotionInformativeContentSubtle: qa,
  emotionInformativeStateActive: Ea,
  emotionInformativeStateDefault: Ga,
  emotionInformativeStateHover: Ja,
  emotionSuccessBackgroundBasic: Ka,
  emotionSuccessBackgroundSubtle: Na,
  emotionSuccessBorderBasic: Qa,
  emotionSuccessBorderSubtle: Ya,
  emotionSuccessContentBasic: Za,
  emotionSuccessContentSubtle: tc,
  emotionSuccessStateActive: ec,
  emotionSuccessStateDefault: oc,
  emotionSuccessStateHover: nc,
  emotionWarningBackgroundBasic: rc,
  emotionWarningBackgroundSubtle: ac,
  emotionWarningBorderBasic: cc,
  emotionWarningBorderSubtle: ic,
  emotionWarningContentBasic: sc,
  emotionWarningContentSubtle: lc,
  emotionWarningStateActive: dc,
  emotionWarningStateDefault: fc,
  emotionWarningStateHover: mc,
  focusFocusRingColor01: Sc,
  formFieldDanger: uc,
  formFieldFilledBackgroundStateActive: gc,
  formFieldFilledBackgroundStateDefault: pc,
  formFieldFilledBackgroundStateHover: bc,
  formFieldFilledBorderStateActive: vc,
  formFieldFilledBorderStateDefault: Bc,
  formFieldFilledBorderStateHover: yc,
  formFieldFilledBorderStateSelected: kc,
  formFieldFilledContent: $c,
  formFieldFilledPlaceholder: hc,
  formFieldHelperText: Hc,
  formFieldLabel: Fc,
  formFieldSuccess: Cc,
  formFieldWarning: Ic,
  gradientBasicOverlayColor01: Dc,
  gradientBasicOverlayColor02: xc,
  gradientPrimaryColor01: Wc,
  gradientPrimaryColor02: Ac,
  gradientSecondaryColor01: Tc,
  gradientSecondaryColor02: Pc,
  gradientSkeletonColor01: zc,
  gradientSkeletonColor02: wc,
  gradientSkeletonColor03: Rc,
  linkPrimaryStateActive: Mc,
  linkPrimaryStateDefault: Uc,
  linkPrimaryStateHover: Lc,
  linkSecondaryStateActive: Oc,
  linkSecondaryStateDefault: Xc,
  linkSecondaryStateHover: _c,
  linkStateVisited: Vc,
  linkTertiaryStateActive: jc,
  linkTertiaryStateDefault: qc,
  linkTertiaryStateHover: Ec,
  neutralBackgroundBasic: Gc,
  neutralBackgroundSubtle: Jc,
  neutralBorderBasic: Kc,
  neutralBorderSubtle: Nc,
  neutralContentBasic: Qc,
  neutralContentSubtle: Yc,
  neutralStateActive: Zc,
  neutralStateDefault: ti,
  neutralStateHover: ei,
  selectedContentBasic: oi,
  selectedContentSubtle: ni,
  selectedStateActive: ri,
  selectedStateDefault: ai,
  selectedStateHover: ci,
  shadowShadow100Color01: ii,
  shadowShadow200Color01: si,
  shadowShadow300Color01: li,
  shadowShadow400Color01: di,
  textPrimary: fi,
  textSecondary: mi,
  textTertiary: Si
}, Symbol.toStringTag, { value: "Module" })), gi = "var(--spirit-color-accent-01-background-basic)", pi = "var(--spirit-color-accent-01-background-subtle)", bi = "var(--spirit-color-accent-01-border-basic)", vi = "var(--spirit-color-accent-01-border-subtle)", Bi = "var(--spirit-color-accent-01-content-basic)", yi = "var(--spirit-color-accent-01-content-subtle)", ki = "var(--spirit-color-accent-01-state-active)", $i = "var(--spirit-color-accent-01-state-default)", hi = "var(--spirit-color-accent-01-state-hover)", Hi = "var(--spirit-color-accent-02-background-basic)", Fi = "var(--spirit-color-accent-02-background-subtle)", Ci = "var(--spirit-color-accent-02-border-basic)", Ii = "var(--spirit-color-accent-02-border-subtle)", Di = "var(--spirit-color-accent-02-content-basic)", xi = "var(--spirit-color-accent-02-content-subtle)", Wi = "var(--spirit-color-accent-02-state-active)", Ai = "var(--spirit-color-accent-02-state-default)", Ti = "var(--spirit-color-accent-02-state-hover)", Pi = "var(--spirit-color-background-backdrop)", zi = "var(--spirit-color-background-interactive-state-active)", wi = "var(--spirit-color-background-interactive-state-default)", Ri = "var(--spirit-color-background-interactive-state-hover)", Mi = "var(--spirit-color-background-primary)", Ui = "var(--spirit-color-background-secondary)", Li = "var(--spirit-color-background-tertiary)", Oi = "var(--spirit-color-border-basic)", Xi = "var(--spirit-color-border-focus)", _i = "var(--spirit-color-border-interactive-state-active)", Vi = "var(--spirit-color-border-interactive-state-default)", ji = "var(--spirit-color-border-interactive-state-hover)", qi = "var(--spirit-color-border-interactive-state-selected)", Ei = "var(--spirit-color-component-button-plain-border)", Gi = "var(--spirit-color-component-button-plain-content)", Ji = "var(--spirit-color-component-button-plain-state-active)", Ki = "var(--spirit-color-component-button-plain-state-default)", Ni = "var(--spirit-color-component-button-plain-state-hover)", Qi = "var(--spirit-color-component-button-primary-border)", Yi = "var(--spirit-color-component-button-primary-content)", Zi = "var(--spirit-color-component-button-primary-content-selected)", ts = "var(--spirit-color-component-button-primary-state-active)", es = "var(--spirit-color-component-button-primary-state-default)", os = "var(--spirit-color-component-button-primary-state-hover)", ns = "var(--spirit-color-component-button-primary-state-selected)", rs = "var(--spirit-color-component-button-secondary-border)", as = "var(--spirit-color-component-button-secondary-content)", cs = "var(--spirit-color-component-button-secondary-content-selected)", is = "var(--spirit-color-component-button-secondary-state-active)", ss = "var(--spirit-color-component-button-secondary-state-default)", ls = "var(--spirit-color-component-button-secondary-state-hover)", ds = "var(--spirit-color-component-button-secondary-state-selected)", fs = "var(--spirit-color-component-button-tertiary-border)", ms = "var(--spirit-color-component-button-tertiary-content)", Ss = "var(--spirit-color-component-button-tertiary-content-selected)", us = "var(--spirit-color-component-button-tertiary-state-active)", gs = "var(--spirit-color-component-button-tertiary-state-default)", ps = "var(--spirit-color-component-button-tertiary-state-hover)", bs = "var(--spirit-color-component-button-tertiary-state-selected)", vs = "var(--spirit-color-component-header-background)", Bs = "var(--spirit-color-component-header-border)", ys = "var(--spirit-color-component-header-item-background-state-active)", ks = "var(--spirit-color-component-header-item-background-state-default)", $s = "var(--spirit-color-component-header-item-background-state-hover)", hs = "var(--spirit-color-component-header-item-background-state-selected)", Hs = "var(--spirit-color-component-header-item-state-active)", Fs = "var(--spirit-color-component-header-item-state-default)", Cs = "var(--spirit-color-component-header-item-state-hover)", Is = "var(--spirit-color-component-header-item-state-selected)", Ds = "var(--spirit-color-component-header-stripe-state-selected)", xs = "var(--spirit-color-component-header-stripe-state-unselected)", Ws = "var(--spirit-color-component-toggle-selected-border)", As = "var(--spirit-color-component-toggle-selected-content)", Ts = "var(--spirit-color-component-toggle-selected-state-active)", Ps = "var(--spirit-color-component-toggle-selected-state-default)", zs = "var(--spirit-color-component-toggle-selected-state-hover)", ws = "var(--spirit-color-component-toggle-unselected-border)", Rs = "var(--spirit-color-component-toggle-unselected-content)", Ms = "var(--spirit-color-component-toggle-unselected-state-active)", Us = "var(--spirit-color-component-toggle-unselected-state-default)", Ls = "var(--spirit-color-component-toggle-unselected-state-hover)", Os = "var(--spirit-color-disabled-background)", Xs = "var(--spirit-color-disabled-border)", _s = "var(--spirit-color-disabled-content)", Vs = "var(--spirit-color-disabled-foreground)", js = "var(--spirit-color-emotion-danger-background-basic)", qs = "var(--spirit-color-emotion-danger-background-subtle)", Es = "var(--spirit-color-emotion-danger-border-basic)", Gs = "var(--spirit-color-emotion-danger-border-subtle)", Js = "var(--spirit-color-emotion-danger-content-basic)", Ks = "var(--spirit-color-emotion-danger-content-subtle)", Ns = "var(--spirit-color-emotion-danger-state-active)", Qs = "var(--spirit-color-emotion-danger-state-default)", Ys = "var(--spirit-color-emotion-danger-state-hover)", Zs = "var(--spirit-color-emotion-informative-background-basic)", tl = "var(--spirit-color-emotion-informative-background-subtle)", el = "var(--spirit-color-emotion-informative-border-basic)", ol = "var(--spirit-color-emotion-informative-border-subtle)", nl = "var(--spirit-color-emotion-informative-content-basic)", rl = "var(--spirit-color-emotion-informative-content-subtle)", al = "var(--spirit-color-emotion-informative-state-active)", cl = "var(--spirit-color-emotion-informative-state-default)", il = "var(--spirit-color-emotion-informative-state-hover)", sl = "var(--spirit-color-emotion-success-background-basic)", ll = "var(--spirit-color-emotion-success-background-subtle)", dl = "var(--spirit-color-emotion-success-border-basic)", fl = "var(--spirit-color-emotion-success-border-subtle)", ml = "var(--spirit-color-emotion-success-content-basic)", Sl = "var(--spirit-color-emotion-success-content-subtle)", ul = "var(--spirit-color-emotion-success-state-active)", gl = "var(--spirit-color-emotion-success-state-default)", pl = "var(--spirit-color-emotion-success-state-hover)", bl = "var(--spirit-color-emotion-warning-background-basic)", vl = "var(--spirit-color-emotion-warning-background-subtle)", Bl = "var(--spirit-color-emotion-warning-border-basic)", yl = "var(--spirit-color-emotion-warning-border-subtle)", kl = "var(--spirit-color-emotion-warning-content-basic)", $l = "var(--spirit-color-emotion-warning-content-subtle)", hl = "var(--spirit-color-emotion-warning-state-active)", Hl = "var(--spirit-color-emotion-warning-state-default)", Fl = "var(--spirit-color-emotion-warning-state-hover)", Cl = "var(--spirit-color-focus-focus-ring-color-01)", Il = "var(--spirit-color-form-field-danger)", Dl = "var(--spirit-color-form-field-filled-background-state-active)", xl = "var(--spirit-color-form-field-filled-background-state-default)", Wl = "var(--spirit-color-form-field-filled-background-state-hover)", Al = "var(--spirit-color-form-field-filled-border-state-active)", Tl = "var(--spirit-color-form-field-filled-border-state-default)", Pl = "var(--spirit-color-form-field-filled-border-state-hover)", zl = "var(--spirit-color-form-field-filled-border-state-selected)", wl = "var(--spirit-color-form-field-filled-content)", Rl = "var(--spirit-color-form-field-filled-placeholder)", Ml = "var(--spirit-color-form-field-helper-text)", Ul = "var(--spirit-color-form-field-label)", Ll = "var(--spirit-color-form-field-success)", Ol = "var(--spirit-color-form-field-warning)", Xl = "var(--spirit-color-gradient-basic-overlay-color-01)", _l = "var(--spirit-color-gradient-basic-overlay-color-02)", Vl = "var(--spirit-color-gradient-primary-color-01)", jl = "var(--spirit-color-gradient-primary-color-02)", ql = "var(--spirit-color-gradient-secondary-color-01)", El = "var(--spirit-color-gradient-secondary-color-02)", Gl = "var(--spirit-color-gradient-skeleton-color-01)", Jl = "var(--spirit-color-gradient-skeleton-color-02)", Kl = "var(--spirit-color-gradient-skeleton-color-03)", Nl = "var(--spirit-color-link-primary-state-active)", Ql = "var(--spirit-color-link-primary-state-default)", Yl = "var(--spirit-color-link-primary-state-hover)", Zl = "var(--spirit-color-link-secondary-state-active)", td = "var(--spirit-color-link-secondary-state-default)", ed = "var(--spirit-color-link-secondary-state-hover)", od = "var(--spirit-color-link-state-visited)", nd = "var(--spirit-color-link-tertiary-state-active)", rd = "var(--spirit-color-link-tertiary-state-default)", ad = "var(--spirit-color-link-tertiary-state-hover)", cd = "var(--spirit-color-neutral-background-basic)", id = "var(--spirit-color-neutral-background-subtle)", sd = "var(--spirit-color-neutral-border-basic)", ld = "var(--spirit-color-neutral-border-subtle)", dd = "var(--spirit-color-neutral-content-basic)", fd = "var(--spirit-color-neutral-content-subtle)", md = "var(--spirit-color-neutral-state-active)", Sd = "var(--spirit-color-neutral-state-default)", ud = "var(--spirit-color-neutral-state-hover)", gd = "var(--spirit-color-selected-content-basic)", pd = "var(--spirit-color-selected-content-subtle)", bd = "var(--spirit-color-selected-state-active)", vd = "var(--spirit-color-selected-state-default)", Bd = "var(--spirit-color-selected-state-hover)", yd = "var(--spirit-color-shadow-shadow-100-color-01)", kd = "var(--spirit-color-shadow-shadow-200-color-01)", $d = "var(--spirit-color-shadow-shadow-300-color-01)", hd = "var(--spirit-color-shadow-shadow-400-color-01)", Hd = "var(--spirit-color-text-primary)", Fd = "var(--spirit-color-text-secondary)", Cd = "var(--spirit-color-text-tertiary)", Id = {
  "01": {
    backgroundBasic: gi,
    backgroundSubtle: pi,
    borderBasic: bi,
    borderSubtle: vi,
    contentBasic: Bi,
    contentSubtle: yi,
    stateActive: ki,
    stateDefault: $i,
    stateHover: hi
  },
  "02": {
    backgroundBasic: Hi,
    backgroundSubtle: Fi,
    borderBasic: Ci,
    borderSubtle: Ii,
    contentBasic: Di,
    contentSubtle: xi,
    stateActive: Wi,
    stateDefault: Ai,
    stateHover: Ti
  }
}, Dd = {
  backdrop: Pi,
  interactive: {
    stateActive: zi,
    stateDefault: wi,
    stateHover: Ri
  },
  primary: Mi,
  secondary: Ui,
  tertiary: Li
}, xd = {
  basic: Oi,
  focus: Xi,
  interactive: {
    stateActive: _i,
    stateDefault: Vi,
    stateHover: ji,
    stateSelected: qi
  }
}, Wd = {
  button: {
    plain: {
      border: Ei,
      content: Gi,
      stateActive: Ji,
      stateDefault: Ki,
      stateHover: Ni
    },
    primary: {
      border: Qi,
      content: Yi,
      contentSelected: Zi,
      stateActive: ts,
      stateDefault: es,
      stateHover: os,
      stateSelected: ns
    },
    secondary: {
      border: rs,
      content: as,
      contentSelected: cs,
      stateActive: is,
      stateDefault: ss,
      stateHover: ls,
      stateSelected: ds
    },
    tertiary: {
      border: fs,
      content: ms,
      contentSelected: Ss,
      stateActive: us,
      stateDefault: gs,
      stateHover: ps,
      stateSelected: bs
    }
  },
  header: {
    background: vs,
    border: Bs,
    itemBackgroundStateActive: ys,
    itemBackgroundStateDefault: ks,
    itemBackgroundStateHover: $s,
    itemBackgroundStateSelected: hs,
    itemStateActive: Hs,
    itemStateDefault: Fs,
    itemStateHover: Cs,
    itemStateSelected: Is,
    stripeStateSelected: Ds,
    stripeStateUnselected: xs
  },
  toggle: {
    selectedBorder: Ws,
    selectedContent: As,
    selectedStateActive: Ts,
    selectedStateDefault: Ps,
    selectedStateHover: zs,
    unselectedBorder: ws,
    unselectedContent: Rs,
    unselectedStateActive: Ms,
    unselectedStateDefault: Us,
    unselectedStateHover: Ls
  }
}, Ad = {
  background: Os,
  border: Xs,
  content: _s,
  foreground: Vs
}, Td = {
  danger: {
    backgroundBasic: js,
    backgroundSubtle: qs,
    borderBasic: Es,
    borderSubtle: Gs,
    contentBasic: Js,
    contentSubtle: Ks,
    stateActive: Ns,
    stateDefault: Qs,
    stateHover: Ys
  },
  informative: {
    backgroundBasic: Zs,
    backgroundSubtle: tl,
    borderBasic: el,
    borderSubtle: ol,
    contentBasic: nl,
    contentSubtle: rl,
    stateActive: al,
    stateDefault: cl,
    stateHover: il
  },
  success: {
    backgroundBasic: sl,
    backgroundSubtle: ll,
    borderBasic: dl,
    borderSubtle: fl,
    contentBasic: ml,
    contentSubtle: Sl,
    stateActive: ul,
    stateDefault: gl,
    stateHover: pl
  },
  warning: {
    backgroundBasic: bl,
    backgroundSubtle: vl,
    borderBasic: Bl,
    borderSubtle: yl,
    contentBasic: kl,
    contentSubtle: $l,
    stateActive: hl,
    stateDefault: Hl,
    stateHover: Fl
  }
}, Pd = {
  focusRing: {
    color01: Cl
  }
}, zd = {
  danger: Il,
  filled: {
    backgroundStateActive: Dl,
    backgroundStateDefault: xl,
    backgroundStateHover: Wl,
    borderStateActive: Al,
    borderStateDefault: Tl,
    borderStateHover: Pl,
    borderStateSelected: zl,
    content: wl,
    placeholder: Rl
  },
  helperText: Ml,
  label: Ul,
  success: Ll,
  warning: Ol
}, wd = {
  basicOverlay: {
    color01: Xl,
    color02: _l
  },
  primary: {
    color01: Vl,
    color02: jl
  },
  secondary: {
    color01: ql,
    color02: El
  },
  skeleton: {
    color01: Gl,
    color02: Jl,
    color03: Kl
  }
}, Rd = {
  primary: {
    stateActive: Nl,
    stateDefault: Ql,
    stateHover: Yl
  },
  secondary: {
    stateActive: Zl,
    stateDefault: td,
    stateHover: ed
  },
  stateVisited: od,
  tertiary: {
    stateActive: nd,
    stateDefault: rd,
    stateHover: ad
  }
}, Md = {
  backgroundBasic: cd,
  backgroundSubtle: id,
  borderBasic: sd,
  borderSubtle: ld,
  contentBasic: dd,
  contentSubtle: fd,
  stateActive: md,
  stateDefault: Sd,
  stateHover: ud
}, Ud = {
  contentBasic: gd,
  contentSubtle: pd,
  stateActive: bd,
  stateDefault: vd,
  stateHover: Bd
}, Ld = {
  shadow100: {
    color01: yd
  },
  shadow200: {
    color01: kd
  },
  shadow300: {
    color01: $d
  },
  shadow400: {
    color01: hd
  }
}, Od = {
  primary: Hd,
  secondary: Fd,
  tertiary: Cd
}, nf = {
  accent: Id,
  background: Dd,
  border: xd,
  component: Wd,
  disabled: Ad,
  emotion: Td,
  focus: Pd,
  formField: zd,
  gradient: wd,
  link: Rd,
  neutral: Md,
  selected: Ud,
  shadow: Ld,
  text: Od
}, rf = {
  themeLightDefault: {
    tokens: ir
  },
  themeLightOnBrand: {
    tokens: ui
  }
};
export {
  gi as accent01BackgroundBasic,
  pi as accent01BackgroundSubtle,
  bi as accent01BorderBasic,
  vi as accent01BorderSubtle,
  Bi as accent01ContentBasic,
  yi as accent01ContentSubtle,
  ki as accent01StateActive,
  $i as accent01StateDefault,
  hi as accent01StateHover,
  Hi as accent02BackgroundBasic,
  Fi as accent02BackgroundSubtle,
  Ci as accent02BorderBasic,
  Ii as accent02BorderSubtle,
  Di as accent02ContentBasic,
  xi as accent02ContentSubtle,
  Wi as accent02StateActive,
  Ai as accent02StateDefault,
  Ti as accent02StateHover,
  Id as accentColors,
  Pi as backgroundBackdrop,
  Dd as backgroundColors,
  zi as backgroundInteractiveStateActive,
  wi as backgroundInteractiveStateDefault,
  Ri as backgroundInteractiveStateHover,
  Mi as backgroundPrimary,
  Ui as backgroundSecondary,
  Li as backgroundTertiary,
  pt as bodyLargeBold,
  bt as bodyLargeItalic,
  gt as bodyLargeRegular,
  zt as bodyLargeSemibold,
  vt as bodyMediumBold,
  Bt as bodyMediumItalic,
  ut as bodyMediumRegular,
  wt as bodyMediumSemibold,
  kt as bodySmallBold,
  $t as bodySmallItalic,
  yt as bodySmallRegular,
  Rt as bodySmallSemibold,
  At as bodyXlargeBold,
  Tt as bodyXlargeItalic,
  Wt as bodyXlargeRegular,
  Pt as bodyXlargeSemibold,
  Dt as bodyXsmallBold,
  xt as bodyXsmallItalic,
  It as bodyXsmallRegular,
  Mt as bodyXsmallSemibold,
  Oi as borderBasic,
  xd as borderColors,
  Xi as borderFocus,
  _i as borderInteractiveStateActive,
  Vi as borderInteractiveStateDefault,
  ji as borderInteractiveStateHover,
  qi as borderInteractiveStateSelected,
  qd as borderWidth0,
  Ed as borderWidth100,
  Gd as borderWidth200,
  e as breakpointDesktop,
  Xd as breakpointMobile,
  t as breakpointTablet,
  Vd as breakpoints,
  S as buttonLargeRadiusDesktop,
  f as buttonLargeRadiusMobile,
  m as buttonLargeRadiusTablet,
  p as buttonMediumRadiusDesktop,
  u as buttonMediumRadiusMobile,
  g as buttonMediumRadiusTablet,
  B as buttonSmallRadiusDesktop,
  b as buttonSmallRadiusMobile,
  v as buttonSmallRadiusTablet,
  _d as buttons,
  nf as colors,
  Ei as componentButtonPlainBorder,
  Gi as componentButtonPlainContent,
  Ji as componentButtonPlainStateActive,
  Ki as componentButtonPlainStateDefault,
  Ni as componentButtonPlainStateHover,
  Qi as componentButtonPrimaryBorder,
  Yi as componentButtonPrimaryContent,
  Zi as componentButtonPrimaryContentSelected,
  ts as componentButtonPrimaryStateActive,
  es as componentButtonPrimaryStateDefault,
  os as componentButtonPrimaryStateHover,
  ns as componentButtonPrimaryStateSelected,
  rs as componentButtonSecondaryBorder,
  as as componentButtonSecondaryContent,
  cs as componentButtonSecondaryContentSelected,
  is as componentButtonSecondaryStateActive,
  ss as componentButtonSecondaryStateDefault,
  ls as componentButtonSecondaryStateHover,
  ds as componentButtonSecondaryStateSelected,
  fs as componentButtonTertiaryBorder,
  ms as componentButtonTertiaryContent,
  Ss as componentButtonTertiaryContentSelected,
  us as componentButtonTertiaryStateActive,
  gs as componentButtonTertiaryStateDefault,
  ps as componentButtonTertiaryStateHover,
  bs as componentButtonTertiaryStateSelected,
  Wd as componentColors,
  vs as componentHeaderBackground,
  Bs as componentHeaderBorder,
  ys as componentHeaderItemBackgroundStateActive,
  ks as componentHeaderItemBackgroundStateDefault,
  $s as componentHeaderItemBackgroundStateHover,
  hs as componentHeaderItemBackgroundStateSelected,
  Hs as componentHeaderItemStateActive,
  Fs as componentHeaderItemStateDefault,
  Cs as componentHeaderItemStateHover,
  Is as componentHeaderItemStateSelected,
  Ds as componentHeaderStripeStateSelected,
  xs as componentHeaderStripeStateUnselected,
  Ws as componentToggleSelectedBorder,
  As as componentToggleSelectedContent,
  Ts as componentToggleSelectedStateActive,
  Ps as componentToggleSelectedStateDefault,
  zs as componentToggleSelectedStateHover,
  ws as componentToggleUnselectedBorder,
  Rs as componentToggleUnselectedContent,
  Ms as componentToggleUnselectedStateActive,
  Us as componentToggleUnselectedStateDefault,
  Ls as componentToggleUnselectedStateHover,
  W as containerLargeMaxWidth,
  A as containerMaxWidth,
  x as containerMediumMaxWidth,
  C as containerPaddingDesktop,
  H as containerPaddingMobile,
  F as containerPaddingTablet,
  D as containerSmallMaxWidth,
  T as containerXlargeMaxWidth,
  I as containerXsmallMaxWidth,
  Nd as containers,
  Kd as cssVariablePrefix,
  Os as disabledBackground,
  Xs as disabledBorder,
  Ad as disabledColors,
  _s as disabledContent,
  Vs as disabledForeground,
  Td as emotionColors,
  js as emotionDangerBackgroundBasic,
  qs as emotionDangerBackgroundSubtle,
  Es as emotionDangerBorderBasic,
  Gs as emotionDangerBorderSubtle,
  Js as emotionDangerContentBasic,
  Ks as emotionDangerContentSubtle,
  Ns as emotionDangerStateActive,
  Qs as emotionDangerStateDefault,
  Ys as emotionDangerStateHover,
  Zs as emotionInformativeBackgroundBasic,
  tl as emotionInformativeBackgroundSubtle,
  el as emotionInformativeBorderBasic,
  ol as emotionInformativeBorderSubtle,
  nl as emotionInformativeContentBasic,
  rl as emotionInformativeContentSubtle,
  al as emotionInformativeStateActive,
  cl as emotionInformativeStateDefault,
  il as emotionInformativeStateHover,
  sl as emotionSuccessBackgroundBasic,
  ll as emotionSuccessBackgroundSubtle,
  dl as emotionSuccessBorderBasic,
  fl as emotionSuccessBorderSubtle,
  ml as emotionSuccessContentBasic,
  Sl as emotionSuccessContentSubtle,
  ul as emotionSuccessStateActive,
  gl as emotionSuccessStateDefault,
  pl as emotionSuccessStateHover,
  bl as emotionWarningBackgroundBasic,
  vl as emotionWarningBackgroundSubtle,
  Bl as emotionWarningBorderBasic,
  yl as emotionWarningBorderSubtle,
  kl as emotionWarningContentBasic,
  $l as emotionWarningContentSubtle,
  hl as emotionWarningStateActive,
  Hl as emotionWarningStateDefault,
  Fl as emotionWarningStateHover,
  Zd as focus,
  Pd as focusColors,
  Cl as focusFocusRingColor01,
  j as focusRing,
  zd as formFieldColors,
  Il as formFieldDanger,
  Dl as formFieldFilledBackgroundStateActive,
  xl as formFieldFilledBackgroundStateDefault,
  Wl as formFieldFilledBackgroundStateHover,
  Al as formFieldFilledBorderStateActive,
  Tl as formFieldFilledBorderStateDefault,
  Pl as formFieldFilledBorderStateHover,
  zl as formFieldFilledBorderStateSelected,
  wl as formFieldFilledContent,
  Rl as formFieldFilledPlaceholder,
  Ml as formFieldHelperText,
  Ul as formFieldLabel,
  d as formFieldLargeRadiusDesktop,
  s as formFieldLargeRadiusMobile,
  l as formFieldLargeRadiusTablet,
  i as formFieldMediumRadiusDesktop,
  a as formFieldMediumRadiusMobile,
  c as formFieldMediumRadiusTablet,
  r as formFieldSmallRadiusDesktop,
  o as formFieldSmallRadiusMobile,
  n as formFieldSmallRadiusTablet,
  Ll as formFieldSuccess,
  Ol as formFieldWarning,
  jd as formFields,
  y as gradientBasicOverlay,
  Xl as gradientBasicOverlayColor01,
  _l as gradientBasicOverlayColor02,
  wd as gradientColors,
  k as gradientPrimary,
  Vl as gradientPrimaryColor01,
  jl as gradientPrimaryColor02,
  $ as gradientSecondary,
  ql as gradientSecondaryColor01,
  El as gradientSecondaryColor02,
  h as gradientSkeleton,
  Gl as gradientSkeletonColor01,
  Jl as gradientSkeletonColor02,
  Kl as gradientSkeletonColor03,
  Jd as gradients,
  R as gridColumns,
  z as gridSpacingDesktop,
  P as gridSpacingMobile,
  w as gridSpacingTablet,
  Qd as grids,
  ht as headingLargeBold,
  qt as headingLargeItalic,
  Vt as headingLargeRegular,
  jt as headingLargeSemibold,
  Ht as headingMediumBold,
  Jt as headingMediumItalic,
  Et as headingMediumRegular,
  Gt as headingMediumSemibold,
  Ft as headingSmallBold,
  Nt as headingSmallItalic,
  Kt as headingSmallRegular,
  Ut as headingSmallSemibold,
  St as headingXlargeBold,
  _t as headingXlargeItalic,
  Ot as headingXlargeRegular,
  Xt as headingXlargeSemibold,
  Ct as headingXsmallBold,
  Yt as headingXsmallItalic,
  Qt as headingXsmallRegular,
  Lt as headingXsmallSemibold,
  Rd as linkColors,
  Nl as linkPrimaryStateActive,
  Ql as linkPrimaryStateDefault,
  Yl as linkPrimaryStateHover,
  Zl as linkSecondaryStateActive,
  td as linkSecondaryStateDefault,
  ed as linkSecondaryStateHover,
  od as linkStateVisited,
  nd as linkTertiaryStateActive,
  rd as linkTertiaryStateDefault,
  ad as linkTertiaryStateHover,
  cd as neutralBackgroundBasic,
  id as neutralBackgroundSubtle,
  sd as neutralBorderBasic,
  ld as neutralBorderSubtle,
  Md as neutralColors,
  dd as neutralContentBasic,
  fd as neutralContentSubtle,
  md as neutralStateActive,
  Sd as neutralStateDefault,
  ud as neutralStateHover,
  Yd as radii,
  M as radius0,
  U as radius100,
  L as radius200,
  O as radius300,
  X as radius400,
  _ as radius500,
  V as radiusFull,
  Ud as selectedColors,
  gd as selectedContentBasic,
  pd as selectedContentSubtle,
  bd as selectedStateActive,
  vd as selectedStateDefault,
  Bd as selectedStateHover,
  q as shadow100,
  E as shadow200,
  G as shadow300,
  J as shadow400,
  Ld as shadowColors,
  yd as shadowShadow100Color01,
  kd as shadowShadow200Color01,
  $d as shadowShadow300Color01,
  hd as shadowShadow400Color01,
  tf as shadows,
  K as space0,
  N as space100,
  at as space1000,
  ct as space1100,
  it as space1200,
  st as space1300,
  lt as space1400,
  dt as space1500,
  ft as space1600,
  mt as space1700,
  Q as space200,
  Y as space300,
  Z as space400,
  tt as space500,
  et as space600,
  ot as space700,
  nt as space800,
  rt as space900,
  ef as spaces,
  of as styles,
  Od as textColors,
  Hd as textPrimary,
  Fd as textSecondary,
  Cd as textTertiary,
  rf as themes
};
